import React from 'react';
import { classNames } from '../utils';
import * as styles from '../css/powering-image.css';

export type Logo =
    'bkk' |
    'vbusz' |
    'kti' |
    'mmkm' |
    'otp' |
    'paks' |
    'szombathely' |
    'szekesfehervar' |
    'mav' |
    'stadtnavi' |
    'tbusz' |
    'thurybusz' |
    'impulse' |
    'eit' |
    'carnet' |
    'realCity' |
    'kadikoy' |
    'carris';

interface Props {
    logo: Logo;
    gapSize?: 'small' | 'large';
}

const PoweringImage = ({ logo, gapSize = 'small' }: Props) => (
    <div className={
        classNames(
            styles.root,
            styles[`${logo}Logo` as const],
            gapSize === 'small' ? styles.smallGap : styles.largeGap,
        )
    }
    />
);

export default PoweringImage;
